/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeletePortfolioCommand } from '../../models/delete-portfolio-command';
import { DeletePortfolioCommandResult } from '../../models/delete-portfolio-command-result';

export interface ApiPortfolioDeletePortfolioDelete$Params {
      body?: DeletePortfolioCommand
}

export function apiPortfolioDeletePortfolioDelete(http: HttpClient, rootUrl: string, params?: ApiPortfolioDeletePortfolioDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePortfolioCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioDeletePortfolioDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeletePortfolioCommandResult>;
    })
  );
}

apiPortfolioDeletePortfolioDelete.PATH = '/api/Portfolio/DeletePortfolio';
